export const SET_LS_GRAPH_DATA = "SET_LS_GRAPH_DATA";
export const SET_RS_GRAPH_DATA = "SET_RS_GRAPH_DATA";
export const SET_LS_PS_GRAPH_DATA = "SET_LS_PS_GRAPH_DATA";
export const SET_RS_PS_GRAPH_DATA = "SET_RS_PS_GRAPH_DATA";
export const GET_GRAPH_DATA_SUCCESS = "GET_GRAPH_DATA_SUCCESS";
export const OPEN_SELECT_PUMPS_MODALS_LS = "OPEN_SELECT_PUMPS_MODALS_LS";
export const CLOSE_SELECT_PUMP_LS_MODAL = "CLOSE_SELECT_PUMP_LS_MODAL";
export const SET_SPLIT_GRAPH_PENDING = "SET_SPLIT_GRAPH_PENDING";